<template>
    <Paginate
            v-bind="{...$attrs, ...$props}"
            @input="$emit('input', $event)"
            :page-range="5"
            container-class="VuePagination"
            page-class="VuePagination__page"
            active-class="VuePagination__page--active"
            break-view-class="VuePagination__other-pages"
            prev-class="VuePagination__button VuePagination__button--prev"
            next-class="VuePagination__button"
            prev-text=""
            next-text=""
    >
        <template #prev-content>
            <ArrowIcon/>
        </template>
        <template #nextContent>
            <ArrowIcon/>
        </template>
    </Paginate>
</template>

<script>
import Paginate from "vuejs-paginate";
import ArrowIcon from '@/assets/image/icons/arrow-head-right.svg?inline'

export default {
    name: "Pagination",
    components: {
        Paginate,
        ArrowIcon,
    },
}
</script>

<style lang="scss">
.VuePagination {
  display: flex;
  align-items: center;
  overflow-x: auto;

  &__page {
    outline: none;

    a {
      outline: none;

      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 40px;
      background: $white;
      border: 1px solid $grayLight;
      border-radius: 50%;
      flex-shrink: 0;
      margin: 0 6px;
    }

    &--active a {
      border: 2px solid #3D6BE3;
    }
  }

  &__other-pages a {
    background: none;
    border: none;
    color: $primary;
    width: 10px;
  }

  &__button {
     a {
       outline: none;
       display: block;
       cursor: pointer;
       height: 40px;
       width: 40px;
       border-radius: 50%;
       flex-shrink: 0;
       background-color: #F0F1F2;
       background-image: url("~@/assets/image/icons/arrow-head-right.png");
       background-position: center;
       background-repeat: no-repeat;
     }


    &--prev a {
      transform: scaleX(-1);
    }
  }
}
</style>